// import { useSelector } from 'react-redux';
// import { RootState } from '../store';
import Utils from '../utility';

export const useAuth = () => {
  const token = Utils.getCookie('auth-token');
  return !!token;
};
